// The `/api/me` shape the frontend needs (build plan P3). No token ever appears here; the
// session is a cookie the browser cannot read, and the CSRF token is what writes carry.

import { z } from "zod";
import { RoleSchema } from "./enums";

export const MeSchema = z.object({
  user: z.object({
    id: z.uuid(),
    displayName: z.string(),
    upn: z.string(),
    tenantId: z.uuid(),
    roles: z.array(RoleSchema),
  }),
  session: z.object({
    expiresAt: z.iso.datetime(),
    rolesReevaluatedAt: z.iso.datetime().nullable(),
  }),
  csrfToken: z.string().min(1),
});
export type Me = z.infer<typeof MeSchema>;

/** Why a sign-in was refused, as the denied page receives it. Never the token, never claims. */
export const SIGN_IN_DENIAL_REASONS = [
  "tenant_not_allowed",
  "no_role",
  "privileged_role",
  "privileged_upn",
  "invalid_token",
  "invalid_state",
  "exchange_failed",
] as const;
export const SignInDenialReasonSchema = z.enum(SIGN_IN_DENIAL_REASONS);
export type SignInDenialReason = z.infer<typeof SignInDenialReasonSchema>;
